/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gender2 } from '../models/Gender2';
import type { GetSimeTbPersonByIdnpResponse } from '../models/GetSimeTbPersonByIdnpResponse';
import type { GetSimeTbPersonByIdResponse } from '../models/GetSimeTbPersonByIdResponse';
import type { GetSimeTbPersonListResponse } from '../models/GetSimeTbPersonListResponse';
import type { GetSimeTbTreatmentPlanListResponse } from '../models/GetSimeTbTreatmentPlanListResponse';
import type { GetSimeTbTreatmentPlanResponse } from '../models/GetSimeTbTreatmentPlanResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { NotifyNewCaseTbPersonResponse } from '../models/NotifyNewCaseTbPersonResponse';
import type { TreatmentPlanSortBy3 } from '../models/TreatmentPlanSortBy3';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SimeTbService {
    /**
     * Gets a list of SIME TB treatment plans.
     * Gets a list of SIME TB treatment plans.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param personId Search by person identifier, optional.
     * @param startDate Search by treatment start date, optional.
     * @param endDate Search by treatment end date, optional.
     * @param treatmentType Search by treatment type, optional. Partial search supported.
     * @param sortBy Sorting by start date, end date and treatment type taking into account Romanian and Russian languages, optional.
     * @param sortDirection Sort direction, default descending.
     * @returns GetSimeTbTreatmentPlanListResponse Treatment plans have been retrieved successfully.
     * @throws ApiError
     */
    public static getSimeTbTreatmentPlanListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        personId?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        treatmentType?: string | null,
        sortBy?: TreatmentPlanSortBy3 | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetSimeTbTreatmentPlanListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sime-tb/treatment-plans',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'personId': personId,
                'startDate': startDate,
                'endDate': endDate,
                'treatmentType': treatmentType,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Gets SIME TB treatment plan.
     * Gets SIME TB treatment plan with details.
     * @param id SIME TB treatment plan identifier.
     * @returns GetSimeTbTreatmentPlanResponse The treatment plan has been retrieved successfully.
     * @throws ApiError
     */
    public static getSimeTbTreatmentPlanEndpoint(
        id: string,
    ): CancelablePromise<GetSimeTbTreatmentPlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sime-tb/treatment-plans/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Search for persons in the SIME-TB system.
     * Search for persons in the SIME-TB system by detailed criteria.
     * @param firstName Filter by the person's first name (case-insensitive).
     * @param lastName Filter by the person's last name (case-insensitive).
     * @param gender Filter by gender (e.g., Male, Female).
     * @param birthDate Filter by the person's date of birth.
     * @returns GetSimeTbPersonListResponse Successfully found persons.
     * @throws ApiError
     */
    public static getSimeTbPersonListEndpoint(
        firstName: string,
        lastName: string,
        gender: Gender2,
        birthDate: string,
    ): CancelablePromise<GetSimeTbPersonListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sime-tb/persons',
            query: {
                'firstName': firstName,
                'lastName': lastName,
                'gender': gender,
                'birthDate': birthDate,
            },
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized.`,
                403: `User is not allowed to search.`,
            },
        });
    }
    /**
     * Search a person in the SIME-TB system by its IDNP.
     * Search a person in the SIME-TB system by its IDNP.
     * @param idnp Person's IDNP.
     * @returns GetSimeTbPersonByIdnpResponse Successfully found person.
     * @throws ApiError
     */
    public static getSimeTbPersonByIdnpEndpoint(
        idnp: string,
    ): CancelablePromise<GetSimeTbPersonByIdnpResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sime-tb/persons/by-idnp/{idnp}',
            path: {
                'idnp': idnp,
            },
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized.`,
                403: `User is not allowed to search.`,
                404: `Person not found.`,
            },
        });
    }
    /**
     * Search a person in the SIME TB system by Id.
     * Search a person in the SIME TB system by Id.
     * @param id Person identifier.
     * @returns GetSimeTbPersonByIdResponse Successfully found person.
     * @throws ApiError
     */
    public static getSimeTbPersonByIdEndpoint(
        id: string,
    ): CancelablePromise<GetSimeTbPersonByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sime-tb/persons/by-id/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized.`,
                403: `User is not allowed to search.`,
                404: `Person not found.`,
            },
        });
    }
    /**
     * Notify TB with new case person by ID from the SIME system.
     * Notify TB with new case person by ID from the SIME system.
     * @param id Unique identifier of the person.
     * @returns NotifyNewCaseTbPersonResponse New case person details successfully send.
     * @throws ApiError
     */
    public static notifyNewCaseTbPersonEndpoint(
        id: string,
    ): CancelablePromise<NotifyNewCaseTbPersonResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sime-tb/persons/{id}/notify-new-case',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid request data.`,
                401: `Unauthorized access.`,
                403: `Access is forbidden.`,
            },
        });
    }
}
